import { Calculator, FlaskConical, Landmark, BookOpen, HeartPulse, Palette, Languages } from "lucide-react";

export const ICONS = { Calculator, FlaskConical, Landmark, BookOpen, HeartPulse, Palette, Languages };

export const SubjectIcon = ({ name, ...props }) => {
  const Icon = ICONS[name] || BookOpen;
  return <Icon {...props} />;
};
